import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import set from 'lodash/set';
import { pender } from 'redux-pender';
import { getCarSimple, getEscrowEncarpayDownPayment, getEscrowEstimate, getEscrowWarranty, getPhoto } from 'app/api';

const GET_CAR_INFO = 'escrow.car/GET_CAR_INFO';
const getCarInfo = createAction(GET_CAR_INFO, getCarSimple);

const GET_CAR_PHOTO = 'escrow.car/GET_CAR_PHOTO';
const getCarPhoto = createAction(GET_CAR_PHOTO, getPhoto);

const GET_WARRANTY_INFO = 'escrow.car/GET_WARRANTY_INFO';
const getWarrantyInfo = createAction(GET_WARRANTY_INFO, getEscrowWarranty);

const GET_ESTIMATE_INFO = 'escrow.car/GET_ESTIMATE_INFO';
const getEstimateInfo = createAction(GET_ESTIMATE_INFO, getEscrowEstimate);

const GET_DOWN_PAYMENT = 'escrow.car/GET_DOWN_PAYMENT';
const getDownPayment = createAction(GET_DOWN_PAYMENT, getEscrowEncarpayDownPayment);

const initialState = {
	base: {},
	photos: [],
	warrantyInfo: {
		hasWarranty: false,
		warrantyList: [],
	},
	estimateInfo: {
		carPrice: null,
		transferCost: null,
		sellingCost: null,
		userFee: null,
		extendedWarrantyCost: null,
	},
};

export const escrowCarActions = {
	getCarInfo,
	getCarPhoto,
	getWarrantyInfo,
	getEstimateInfo,
	getDownPayment,
};

export default handleActions(
	{
		...pender({
			type: GET_CAR_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.base = data || {};
				}),
		}),
		...pender({
			type: GET_CAR_PHOTO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.photos = data?.carPhotoInfoList || [];
				}),
		}),
		...pender({
			type: GET_WARRANTY_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					const warrantyList = data
						.map((item) => ({
							...item,
							isWarranty: true,
						}))
						.concat({
							code: 'E01',
							month: 0,
							cost: 0,
							isWarranty: false,
						});

					set(draft, ['warrantyInfo', 'hasWarranty'], true);
					set(draft, ['warrantyInfo', 'warrantyList'], warrantyList);
				}),
		}),
		...pender({
			type: GET_ESTIMATE_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.estimateInfo = data;
				}),
		}),
		...pender({
			type: GET_DOWN_PAYMENT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.estimateInfo.downPayment = data.downPayment;
				}),
		}),
	},
	initialState,
);
